export default __webpack_public_path__ + "static/media/330_business05-es-mobile.55adb27d.png";